import store from '@/store/index.js';

/**
 * Dont show the order pages if you dont have rights.
 */
export default {
    /**
     * Check if we can enter the route.
     *
     * @param {object} to
     * @param {object} from
     * @param {function} next
     */
    beforeRouteEnter(to, from, next) {
        if (store.getters['user/currentCustomer'].availableActions.includes('createOrders')) {
            next();

            return;
        }

        next({ name: 'error.403' });
    }
};
